import {atom} from "jotai";

export const highlightTimeAtom = atom(false);